export default function CorporateIdentitySection() {
  return (
    <section className="py-28 px-8 bg-dark-primary">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-industrial-lighter/20 rounded-full mb-6">
            <span className="text-industrial-lighter text-xs font-medium tracking-[0.12em] uppercase">
              Corporate Legal Identity
            </span>
          </div>
          <h2 className="font-serif text-white text-4xl leading-tight mb-6">
            Legal Entity and Operating Jurisdiction
          </h2>
          <p className="text-industrial-light text-base leading-[1.8] max-w-3xl mb-12">
            Arvakon operates as an independent technical service provider. Services are delivered on a contractual basis to equipment purchasers, project owners, EPC contractors, and original equipment manufacturers.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Legal Status */}
          <div className="bg-dark-card/40 border border-dark-border/30 rounded-lg p-8">
            <h3 className="text-industrial-lighter text-sm font-semibold mb-5 tracking-wide uppercase">
              Legal Status
            </h3>
            <ul className="space-y-3.5">
              {[
                'Independent service provider',
                'No affiliation with manufacturing entities, material suppliers, or equipment vendors',
                'No financial interest in fabrication outcomes or procurement decisions',
                'Operating jurisdiction: [To be specified based on actual registration]',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-industrial-light text-sm">
                  <div className="w-1.5 h-1.5 rounded-full bg-industrial-light mt-2 flex-shrink-0"></div>
                  <span className="leading-[1.75]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Independence Confirmation */}
          <div className="bg-dark-card/40 border border-dark-border/30 rounded-lg p-8">
            <h3 className="text-industrial-lighter text-sm font-semibold mb-5 tracking-wide uppercase">
              Independence Confirmation
            </h3>
            <p className="text-industrial-light text-sm leading-[1.75]">
              Arvakon maintains organizational and financial independence from entities subject to verification activities. Services are provided exclusively on behalf of clients requiring third-party technical oversight.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}